import { render, staticRenderFns } from "./PsychologistProfile.vue?vue&type=template&id=e280477c&"
import script from "./PsychologistProfile.vue?vue&type=script&lang=ts&"
export * from "./PsychologistProfile.vue?vue&type=script&lang=ts&"
import style0 from "./PsychologistProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports